import { Injectable, Injector } from '@angular/core';
import { FormType, OlogNotificationType } from 'src/app/common/enumerations/enumerations';
import { MessagePlaceholder } from 'src/app/common/models/placeholder';
import { FormService } from 'src/app/controls/form-table/form.service';
import { PartialOlogComponent } from 'src/app/components/olog/partial-olog/partial-olog.component';
import { YesNoDialogComponent } from 'src/app/controls/yes-no-dialog/yes-no-dialog.component';
import { OLogService } from 'src/app/components/olog/olog.service';
import { WfSignature, WFConfiguration, WFTaskSignatureResource, SaveTaskResource, WfSignatureResource } from '../workflow/workflow';
import { Form } from 'src/app/services/forms/form';
import { NormalInputDialogComponent } from 'src/app/controls/normal-input-dialog/normal-input-dialog.component';
import { Restriction } from 'src/app/controls/restrictions/services/restriction';
import { Observable, Subscription, tap } from 'rxjs';
import { KEService } from '../kenable/ke.service';
import { BaseService } from 'src/app/common/base/base.service';
import { PPSTB } from './ppstb';
import { IFormService } from 'src/app/common/interfaces/i-form-service';
import { FormBaseV2 } from 'src/app/common/models/model-base';
import { Option } from '../checklists/checklists';
import { WorkFlowService } from '../workflow/workflow.service';
import { FormsRefreshByID } from 'src/app/controls/form-table/store/forms.action';

@Injectable({
  providedIn: 'root'
})
export class PpstbService extends BaseService<PPSTB, number> implements IFormService {
  public currentDocument?: Form;
  public form!: Form;

  restrictions!: Restriction[];
  restrictionsFiltered!: Restriction[];
  restrictions$!: Observable<Restriction[]>;
  restrictionsSubs!: Subscription;

  constructor(
    protected override injector: Injector,
    private formService: FormService,
    private ologService: OLogService,
    private keService: KEService,
    private wfService: WorkFlowService
  ) {
    super(injector, '/PPSTB');
  }

  setAmendmentRequesters(wfSignatures: WfSignatureResource[]): any {
    return wfSignatures;
  }

  loadRestrictions() {
    this.restrictions$ = this.store.select((state) => state.Restrictions.data);
    this.restrictionsSubs = this.restrictions$.subscribe((data) => {
      if (data?.length) {
        this.restrictions = data;
      }
    });
  }

  async confirmSign(form: Form | FormBaseV2 | null | undefined, task: WfSignature, action?: number, data?: any, options?: string, configuration?: WFConfiguration[]) {
    this.loadRestrictions();
    if (form && task && action) {
      this.form = form as Form;
      const reason = data?.text;

      const restrictedResourceIDs = this.restrictions.filter(x => this.form?.formVersion?.ppstb?.ppstbRestrictions?.filter(x => x.restrictionID).map(r => r.restrictionID).includes(x.id)).map(y => y.resourceID).filter((resourceID): resourceID is number => resourceID !== undefined);

      switch (task.code) {
        // Section 2 OIC Approval
        case 'AP-OIC':
        case 'APAM-OIC':
          const confirm = this.dialog.open(YesNoDialogComponent, {
            width: "500px",
            data: {
              message: this.getMessage('finish_message').description,
              icon: "warn",
            },
          });
          confirm.afterClosed().subscribe(async (data) => {
            if (data && form.id && task.taskId) {
              const response = await this.ologService.postToOlog(FormType.PPSTB, form.id, OlogNotificationType.Closed);
              if (response?.ok) {
                await this.sign(this.form, task.taskId, action, reason, options);
                //Refresh KEs
                if (restrictedResourceIDs.length > 0) {
                  this.keService.processKES(restrictedResourceIDs);
                }
              }
              return true;
            }
            else return false;
          });
          break;

        case 'MITNOTREQOIC':
        case 'MITVERIFIER':
          const confirmActive = this.dialog.open(YesNoDialogComponent, {
            width: "500px",
            data: {
              message: this.getMessage('toActiveWarning').description,
              icon: "warn",
            },
          });
          confirmActive.afterClosed().subscribe(async (data) => {
            if (data && form?.id && task?.taskId) {
              const response = await this.ologService.postToOlog(FormType.PPSTB, form.id, OlogNotificationType.Activate);
              if (response?.ok) {
                await this.sign(this.form, task.taskId, action, reason, options);
                //Refresh KEs
                if (restrictedResourceIDs !== undefined && restrictedResourceIDs.length > 0) {
                  this.keService.processKES(restrictedResourceIDs);
                }
              }
              return true;
            }
            else return false;
          });
          break;

        default:
          await this.sign(this.form, task.taskId, action, reason, options);
          return true;
          break;
      }

      // Section 3 Mitigations

      if (configuration?.some(x => x.wfTaskLocalID == task.id && x.identificator == 102)) {

      }



      else if (configuration?.some(x => x.wfTaskLocalID == task.id && x.identificator == 103)) {

      }

      else if (configuration?.some(x => x.wfTaskLocalID === task.id && x.identificator === 108)) {
        const confirm = this.dialog.open(NormalInputDialogComponent, {
          width: '400px',
          data: {
            label: this.getMessage('Enter_A_Reason_To_Disable').description,
            text: '',
            inputType: 'text'
          }
        });
        confirm.afterClosed().subscribe(
          async (data: string) => {
            if (data && task.taskId) {
              await this.sign(this.form, task.taskId, action, data, options);
            }
          }
        );
      } else if (configuration?.some(x => x.wfTaskLocalID === task.id && x.identificator === 107)) {
        const confirm = this.dialog.open(YesNoDialogComponent, {
          width: '500px',
          data: {
            message: this.getMessage('toActiveWarning').description,
            icon: 'warn'
          }
        });
        confirm.afterClosed().subscribe(data => {
          if (data != null) {
            this.dialog.open(NormalInputDialogComponent, {
              width: '400px',
              data: {
                label: this.getMessage('Enter_A_Reason_To_Disable').description,
                text: '',
                inputType: 'text'
              }
            }).afterClosed().subscribe(
              async (data: string) => {
                if (data) {
                  const response = await this.ologService.postToOlog(FormType.PPSTB, form.id, OlogNotificationType.Activate);
                  if (response?.ok) {
                    await this.sign(this.form, task.taskId, action, data);
                    //Refresh KEs
                    if (restrictedResourceIDs !== undefined && restrictedResourceIDs.length > 0) {
                      this.keService.processKES(restrictedResourceIDs);
                    }
                  }
                }
              });
          }
        });
      }
      else {
        if (form.id && task.taskId) {

        }
      }
    }
    return false;
  }

  async sign(form?: Form | null, taskId?: number, actionId?: number, reason?: string, options?: string, amendment?: boolean) {
    if (form?.id && taskId && actionId) {
      this.form = form;
      const formStatus = this.form.formVersion.status;
      const status = formStatus.id;
      const formID = form?.id
      const wfTaskSignature: WFTaskSignatureResource = { taskId, actionId, reason, formID, amendment, options, status };
      const data = await this.formService.sign(wfTaskSignature).toPromise().catch(error => {
        console.error(error);
        this.alert.defaultError();
      });
      if (data?.id) {
        // Reload the active version after a workflow transition so an activated amendment
        // is rendered instead of the previous-version snapshot held by the side list.
        this.store.dispatch(new FormsRefreshByID(data.id));
      }
      if (data && data?.formVersion.statusID != formStatus.id) {
        this.alert.message('formStateChanged', [new MessagePlaceholder("{serialNo}", this.form?.sequenceNumber.number), new MessagePlaceholder('{status}', data.formVersion.status.name)]);
      }
      return data;
    }
    else return undefined;
  }

  async editOlog(form?: Form | null) {
    if (form) {
      try {
        const data = await this.ologService.getOlog(FormType.PPSTB, form.id, OlogNotificationType.Activate).toPromise();
        if (data) {
          const dialogRef = this.dialog.open(PartialOlogComponent, {
            height: "fit-content",
            width: "80%",
            data,
          });
          dialogRef.afterClosed().subscribe();
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  save(form: Form | FormBaseV2): Promise<FormBaseV2> {
    throw new Error('Method not implemented.');
  }

  saveTask(saveTask: SaveTaskResource): Observable<any> {
    return this.wfService.save(saveTask).pipe(
      tap(() => {
        const formId = this.currentDocument?.formVersion?.formID;
        if (formId) {
          this.store.dispatch(new FormsRefreshByID(formId));
        }
      })
    );
  }



}
